export default {
  getIsMobileDensity: (state) => state.isMobileDensity,
  getMessageCount: (state) => state.messageCount,
};
